import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Renders Uhe Facility Cell in the Tables
 * @param {object} content UheFacilityCell Data
 * @returns {JSX.Element} Link
 */
const FacilityCell = ({ content }) => {
  const { id, organizationId, customerId, name } = content;

  return (
    <div className="uhe-table-td" title={name}>
      <Link to={`/configuration/facilities/edit/${id}`}>
        <span>{name}</span>
      </Link>
      <Link to={`/configuration/units?topf_organization=${organizationId}&topf_customer=${customerId}&topf_facility=${id}`} className="search-icon">
        <i className="icon icon-search-new" />
      </Link>
    </div>
  );
};

export default FacilityCell;